const routes = Object.freeze({
  main: "/",
  // ── Alignment Screen Tool ────────────────────────────────────────────────
  ast_tool: "/alignment-tool",
  ast_project_name: "/alignment-tool/project-name",
  ast_identification: "/alignment-tool/identification",
  ast_general_screen: "/alignment-tool/general-screen",
  ast_specific_screen: "/alignment-tool/specific-screen",
  ast_enviroperform: "/alignment-tool/enviroperform",
  ast_results: "/alignment-tool/results",
  ast_request: "/alignment-tool/request",
  // AST step navigation aliases (used by Steps component)
  ast_tool_step_1: "/alignment-tool/identification",
  ast_tool_step_2: "/alignment-tool/general-screen",
  ast_tool_step_3: "/alignment-tool/specific-screen",
  ast_tool_step_4: "/alignment-tool/results",
  // ── Account / public ─────────────────────────────────────────────────────
  account: "/account",
  contacts: "/contacts",
  faq: "/faq",
})

export default routes